import React from "react";
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { db } from "firebase/fbConfig.js";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import Style from "assets/jss/material-dashboard-pro-react/views/actionsStyle";

import InTransitOrders from "./InTransitOrders";

class Principles extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  loadGroups = (uid) => {
    console.log("loading groups")
    db.collection("TEST-users").doc(uid).collection('haney-groups')
      .get()
      .then(
        (snapshot) => {
          const newData = snapshot.docs.map(doc => doc.id);
          return newData;
        },
        (error) => {
          console.log("error fetching data: ", error);
        }
      )
      .then((newData) => {
        this.setState({
          groupsData: newData,
          groupsDataLoaded: true,
        });
      });
  };

  render() {
    const { classes, authUser } = this.props;

    if (authUser) {

      if (!this.state.groupsDataLoaded) {
        this.loadGroups(authUser.uid);

      }
    }

    console.log(this.state)
    console.log(this.props)

    return this.state.groupsDataLoaded ? (
      <InTransitOrders groups={this.state.groupsData} />
    ) : (
      <p className={classes.body}>Loading...</p>
    )
  }
}

const mapStateToProps = (state) => {
  console.log(state)
  return {
    authUser: state.auth.user,
  }
}

export default compose(
  connect(mapStateToProps),
  withStyles(Style)
)(Principles);


// WEBPACK FOOTER //
// ./src/views/Dispatch/InTransitOrdersParent.jsx